/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionSoakDto
 */
export interface AdmissionSoakDto {
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    attempts?: number;
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    accepted?: number;
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    rejected?: number;
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    elapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    maxRunningPerShard?: number;
    /**
     * 
     * @type {number}
     * @memberof AdmissionSoakDto
     */
    shardCount?: number;
}

/**
 * Check if a given object implements the AdmissionSoakDto interface.
 */
export function instanceOfAdmissionSoakDto(value: object): value is AdmissionSoakDto {
    return true;
}

export function AdmissionSoakDtoFromJSON(json: any): AdmissionSoakDto {
    return AdmissionSoakDtoFromJSONTyped(json, false);
}

export function AdmissionSoakDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionSoakDto {
    if (json == null) {
        return json;
    }
    return {
        
        'attempts': json['attempts'] == null ? undefined : json['attempts'],
        'accepted': json['accepted'] == null ? undefined : json['accepted'],
        'rejected': json['rejected'] == null ? undefined : json['rejected'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'maxRunningPerShard': json['maxRunningPerShard'] == null ? undefined : json['maxRunningPerShard'],
        'shardCount': json['shardCount'] == null ? undefined : json['shardCount'],
    };
}

export function AdmissionSoakDtoToJSON(json: any): AdmissionSoakDto {
    return AdmissionSoakDtoToJSONTyped(json, false);
}

export function AdmissionSoakDtoToJSONTyped(value?: AdmissionSoakDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempts': value['attempts'],
        'accepted': value['accepted'],
        'rejected': value['rejected'],
        'elapsedMs': value['elapsedMs'],
        'maxRunningPerShard': value['maxRunningPerShard'],
        'shardCount': value['shardCount'],
    };
}

